import { appConfig } from "@common-config/app.config";

/**
 * Flip to `true` locally when debugging tab-wake / MQTT / server-tool flow.
 * Writes append to `whatsapp-scheduler-backend/logs/tab-wake-events.log`.
 *
 * At scale (100k+ active users) leaving this on generates ~1 POST/sec per tab
 * and synchronous disk writes on the backend — keep it `false` in production.
 */
const TAB_WAKE_LOG_TO_FILE = false;

export interface TabWakeLogEntry {
  eventType: string;
  source: string;
  [key: string]: any;
}

/**
 * Single entry point for tab-wake diagnostic events. Fire-and-forget POST to
 * the backend's `/actions?cmd=log-tab-wake-event` endpoint, which appends a
 * JSON line. No-op when TAB_WAKE_LOG_TO_FILE is false, so callers can leave
 * invocations in place without worrying about prod load.
 */
export function logTabWakeEvent(entry: TabWakeLogEntry): void {
  if (!TAB_WAKE_LOG_TO_FILE) return;
  try {
    fetch(`${appConfig.API_ENDPOINT}/actions`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        cmd: "log-tab-wake-event",
        contextTimestamp: new Date().toISOString(),
        ...entry,
      }),
    }).catch(() => {});
  } catch { /* noop */ }
}
